/* Tweaks figés pour la prod Shopify — valeurs par défaut conservées. */
(function () {
  var Null = function () { return null; };
  window.TweaksPanel = Null;
  window.TweakSection = Null; window.TweakRadio = Null; window.TweakToggle = Null;
  window.TweakSlider = Null; window.TweakSelect = Null; window.TweakText = Null;
  window.TweakNumber = Null; window.TweakColor = Null; window.TweakButton = Null;
  window.useTweaks = function (defaults) { return [defaults, function () {}]; };
})();
